import axios from "axios";

// Solo para cobertura: en local el backend no recibe el request, usamos producción
export const PRODUCTION_API_URL =
  "https://us-central1-xtrim-referidos.cloudfunctions.net/consultasv2/api/v1/";

// Cobertura siempre a producción (función dedicada con VPC connector)
export const COVERAGE_API_URL =
  "https://us-central1-xtrim-referidos.cloudfunctions.net/consultasCobertura/api/v1/";

const isTesting = process.env.NODE_ENV === "development" || process.env.VUE_APP_TESTING === "true";
const baseURL = isTesting
  ? "http://127.0.0.1:5001/xtrim-referidos/us-central1/consultasv2/api/v1/"
  : PRODUCTION_API_URL;

export default axios.create({
  baseURL,
});
